/**-----------------------------------------------------------------------------------------
* Copyright © 2021 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the project root for more information
*-------------------------------------------------------------------------------------------*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("@angular/core");
var kendo_angular_l10n_1 = require("@progress/kendo-angular-l10n");
var messages_1 = require("./messages");
/**
 * Custom component messages override default component messages ([see example]({% slug globalization_dateinputs %}#toc-custom-messages)).
 */
var DateTimePickerCustomMessagesComponent = /** @class */ (function (_super) {
    tslib_1.__extends(DateTimePickerCustomMessagesComponent, _super);
    function DateTimePickerCustomMessagesComponent(service) {
        var _this = _super.call(this) || this;
        _this.service = service;
        return _this;
    }
    DateTimePickerCustomMessagesComponent_1 = DateTimePickerCustomMessagesComponent;
    Object.defineProperty(DateTimePickerCustomMessagesComponent.prototype, "override", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    var DateTimePickerCustomMessagesComponent_1;
    DateTimePickerCustomMessagesComponent = DateTimePickerCustomMessagesComponent_1 = tslib_1.__decorate([
        core_1.Component({
            providers: [
                {
                    provide: messages_1.Messages,
                    useExisting: core_1.forwardRef(function () { return DateTimePickerCustomMessagesComponent_1; })
                }
            ],
            selector: 'kendo-datetimepicker-messages',
            template: ""
        }),
        tslib_1.__metadata("design:paramtypes", [kendo_angular_l10n_1.LocalizationService])
    ], DateTimePickerCustomMessagesComponent);
    return DateTimePickerCustomMessagesComponent;
}(messages_1.Messages));
exports.DateTimePickerCustomMessagesComponent = DateTimePickerCustomMessagesComponent;
